

export enum CriteriaAnswerTypeCode {
  Percentage = "Percentage",
  Numeric = "Numeric",
  Star_Rating = "Star_Rating",
}
